<app-help-page mainVideo="introducing-adloop"
               [tutorials]="['adloop-calendar', 'metric-picker', 'quick-start', 'tracking-and-attribution', 'optimization-process', 'cookie-consent']"
               [videos]="['introducing-adloop', 'quick-dashboard']"></app-help-page>
